<template>
	<nav
		class="provider-and-calendar-nav-mobile padding-top-xs-0 padding-bottom-xs-1"
	>
		<ProviderAndCalendarTypeSelectMobile />
		<SelectProvider />
	</nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import SelectProvider from "./SelectProvider.vue";
import ProviderAndCalendarTypeSelectMobile from "./ProviderAndCalendarTypeSelectMobile.vue";
export default {
	components: { SelectProvider, ProviderAndCalendarTypeSelectMobile },
	computed: {
		...mapState(["ui", "providers"]),
		...mapGetters([])
	},
	methods: {
		...mapActions(["calendarViewType", "toggleSelectingProvider"])
	}
};
</script>